import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SearchParams } from 'src/app/common';
import { Utility, Patterns, setTimeout$ } from 'src/app/core/common';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-company-detail',
  templateUrl: './company-detail.component.html',
  styleUrls: ['./company-detail.component.scss']
})
export class CompanyDetailComponent implements OnInit {

  constructor(private userService: UserService, private sharedService: SharedService, private route: ActivatedRoute,
    private spinner: SpinnerService) {
  }

  Utility = Utility;
  patterns = Patterns;
  imageUrl = environment.app.filesUrl;
  tab = 'jobs';
  showInfo = false;

  company: any;
  logoImage: string;
  headerImage: string;

  code: number;
  companies: string[];
  inline: boolean;
  searchParams = new SearchParams();

  async ngOnInit() {
    await new Promise<void>(resolve => {
      this.route.params.subscribe(async params => {

        if (!isNaN(+params['code'])) this.code = +params['code'];
        else this.companies = [params['code']].filter(_ => _);

        await this.load();
        resolve();
        setTimeout$(() => {
          this.sharedService.scrollToTop();
        });
      });
    });
  }

  private async load() {
    if (!this.code && !this.companies?.length) return;
    this.spinner.show('load');

    if (this.code) {
      this.company = await this.userService.getByEmployerCode(this.code);
      if (this.company?.Employer) {
        this.logoImage = this.company.Employer.Logo
        this.headerImage = this.company.Employer.HeaderImage
        if (this.logoImage)
          this.logoImage = (this.logoImage.startsWith('employer/')) ? `${environment.app.assetsUrl}${this.logoImage}` : `${environment.app.filesUrl}${this.logoImage}`;
        if (this.headerImage)
          this.headerImage = (this.headerImage.startsWith('employer/')) ? `${environment.app.assetsUrl}${this.headerImage}` : `${environment.app.filesUrl}${this.headerImage}`;

        this.companies = [this.company.Employer.Company, ...(this.company.Employer.Variations || [])].filter(_ => _);
      }
    }

    if (this.company)
      this.searchParams = <SearchParams>{ EmployerId: this.company.Id };
    else if (this.companies?.length)
      this.searchParams = <SearchParams>{ Company: this.companies.map(_ => `"${_.replace('"', '')}"`) };
    else return;

    this.setSeo();

    this.spinner.hide('load');
  }

  private setSeo() {
    let companyName = this.companies[0]?.trim() || '';
    this.sharedService.setTitle(`استخدام در ${companyName}`);
    this.sharedService.removeLink('rel=\'canonical\'');
    this.sharedService.addLink({ rel: 'canonical', href: `${environment.app.url}/company/${companyName}` });

    this.sharedService.setKeywordsMeta(...this.companies, ...[<string>this.company?.State, <string>this.company?.City]);
    this.sharedService.setDescriptionMeta('شغل، کار، فرصت‌های شغلی و استخدام در شرکت ' + this.companies.join(' | '));
  }
}
